import { motion } from "motion/react";
import nextcampusbg from "../../../assets/nextcamp.png";
import campuslogo from "../../../assets/Frame 1321314933.png";
import hexa from "../../../assets/hexa.png";
import sqr from "../../../assets/sqr.png";
import mobilebg from "../../../assets/mobilebgcampus.png"
import CampusSlider from "./CampusSlider";
import { useEffect } from "react";
import { useState } from "react";
export default function CampusHeading() {
  const [showBackground, setShowBackground] = useState(false);

  useEffect(() => {
    // Check on mount and window resize
    const handleResize = () => {
      setShowBackground(window.innerWidth >= 780);
    };

    // Initial check
    handleResize();

    // Listen for resize events
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);
  return (
    <div className="relative w-full min-h-screen overflow-x-hidden">
      <div
        className="w-full h-[60vh] md:min-h-screen bg-cover bg-center bg-no-repeat hidden md:block"
        style={{
          backgroundImage: `url(${nextcampusbg})`,
        }}
      >
        <div className="flex flex-col  md:flex-row items-center justify-center w-full px-6 md:px-20 pt-10 ">
          {/* Left Image */}
          {/* <div className="md:w-1/2 bg-slate-300 w-full flex justify-center mb-6 lg:mb-0">
            <img
            src="/mnt/data/bdc2ee2b-925e-4c2d-abf8-22d538ee478e.png"
            alt="Girl"
            className="max-w-[400px] w-full h-auto"
          /> 
          </div> */}

          {/* Right Content */}
          <div className="md:w-1/2 w-full text-center md:ml-[30%] md:text-left md:mt-[90px] lg:mt-[130px]">
            <div className="flex items-center justify-center lg:justify-center flex-wrap">
              <div
                className="font-bold text-5xl text-black"
                style={{ fontFamily: "Montserrat" }}
              >
                NEXTGEN
              </div>
              <img src={campuslogo} className="w-[30%] max-w-[200px]" />
            </div>

            <div className="flex gap-2 p-4 justify-center md:justify-center mt-5 flex-wrap">
              <div
                className="bg-pink-300 text-black font-bold px-4 py-2 rounded-lg hover:bg-pink-400"
                style={{ fontFamily: "Montserrat" }}
              >
                Begin
              </div>

              <div
                className="bg-orange-300 text-black font-bold px-4 py-2 rounded-lg hover:bg-orange-400"
                style={{ fontFamily: "Montserrat" }}
              >
                Breakthrough
              </div>

              <div
                className="bg-yellow-500 text-black font-bold px-4 py-2 rounded-lg hover:bg-yellow-600"
                style={{ fontFamily: "Montserrat" }}
              >
                Become
              </div>
            </div>

            <div className="mt-4 px-2">
              <p
                className="text-black tracking-wider font-semibold text-center hidden xss:block  md:text-[14px] lg:text-[15px] md:text-center"
                style={{ fontFamily: "Poppins" }}
              >
                The NextGen Campus Program transforms education into an
                adventure. Here, classrooms become innovation hubs where
                students master real-world skills, collaborate with industry
                leaders, and fuel their entrepreneurial spirit. It's more than a
                degree it's a launchpad for future creators, problem-solvers,
                and leaders ready to make their mark on the world.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        className="w-full h-auto md:min-h-screen bg-cover bg-center bg-no-repeat md:hidden"
        style={{
          backgroundImage: `url(${mobilebg})`,
        }}
      >
        <div className="flex flex-col  md:flex-row items-center justify-center w-full px-6 md:px-20 pt-10 ">
          {/* Left Image */}
          {/* <div className="md:w-1/2 bg-slate-300 w-full flex justify-center mb-6 lg:mb-0">
            <img
            src="/mnt/data/bdc2ee2b-925e-4c2d-abf8-22d538ee478e.png"
            alt="Girl"
            className="max-w-[400px] w-full h-auto"
          /> 
          </div> */}

          {/* Right Content */}
          <div className="md:w-1/2 w-full text-center md:ml-[30%] md:text-left md:mt-[30px] lg:mt-[130px]">
            <div className="flex items-center justify-center lg:justify-center flex-wrap">
              <div
                className="font-bold text-5xl text-black"
                style={{ fontFamily: "Montserrat" }}
              >
                NEXTGEN
              </div>
              <img src={campuslogo} className="w-[30%] max-w-[200px]" />
            </div>

            <div className="flex gap-2 p-4 justify-center md:justify-center mt-5 flex-wrap">
              <div
                className="bg-pink-300 text-black font-bold px-4 py-2 rounded-lg hover:bg-pink-400"
                style={{ fontFamily: "Montserrat" }}
              >
                Begin
              </div>

              <div
                className="bg-orange-300 text-black font-bold px-4 py-2 rounded-lg hover:bg-orange-400"
                style={{ fontFamily: "Montserrat" }}
              >
                Breakthrough
              </div>

              <div
                className="bg-yellow-500 text-black font-bold px-4 py-2 rounded-lg hover:bg-yellow-600"
                style={{ fontFamily: "Montserrat" }}
              >
                Become
              </div>
            </div>

            <div className="mt-4 px-2">
              <p
                className="text-black tracking-wide text-center  text-[14px] mb-[15px] md:text-[12px] lg:text-[16px] md:text-center"
                style={{ fontFamily: "Poppins" }}
              >
                The NextGen Campus Program transforms education into an
                adventure. Here, classrooms become innovation hubs where
                students master real-world skills, collaborate with industry
                leaders, and fuel their entrepreneurial spirit. It's more than a
                degree it's a launchpad for future creators, problem-solvers,
                and leaders ready to make their mark on the world.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Clouds background section */}
      <div
        className="w-full min-h-screen flex flex-col justify-center mt-[-190px]"
        style={{
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundImage: showBackground
            ? "url('https://dbqa318yoj3nn.cloudfront.net/clouds.png')"
            : "none",
        }}
      >
        <div className="flex items-baseline justify-center text-center w-full mt-[200px] md:mt-[200px]  lg:mt-[90px]">
          <div className="relative inline-block">
            <span
              className="text-[6vw] font-bold text-[rgb(250,168,38)] leading-tight"
              style={{ fontFamily: "Montserrat" }}
            >
              Skills
            </span>
            <img
              src="https://dbqa318yoj3nn.cloudfront.net/design1.svg"
              alt="Underline"
              className="absolute bottom-[-5px] left-0 w-full max-w-[100%]"
            />
          </div>
          <span
            className="text-[#0F1D33] text-[3vw] font-bold ml-2"
            style={{ fontFamily: "Montserrat" }}
          >
            We Develop
          </span>
        </div>
        <div className="relative flex justify-center items-center ">
          <CampusSlider />
        </div>
        <div className="relative flex justify-center items-center mt-[50px]">
          <div
            className="text-4xl md:text-6xl font-bold text-center"
            style={{
              color: "#39B3FF",
              fontFamily: "Luckiest Guy",
              textShadow: "4px 4px 6px rgba(0, 0, 0, 0.2)",
            }}
          >
            highlights of the program
          </div>
        </div>

        {/* <motion.div
          whileHover={{ scale: 1.1 }}
          className="flex justify-center mt-4 text-xl text-center px-4"
          style={{
            fontFamily: "Montserrat",
            textShadow: "4px 4px 6px rgba(0, 0, 0, 0.4)",
          }}
        >
          Learning beyond books, experiencing beyond limits
        </motion.div> */}

        <div
          className="relative flex flex-col lg:flex-row items-center justify-between w-full max-w-screen-xl min-h-screen px-4 md:px-10 py-10 overflow-x-hidden mx-auto"
          style={{ fontFamily: "Poppins" }}
        >
          <motion.div
            animate={{ y: [0, -15, 0] }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut",
            }}
            className="relative w-full lg:w-[650px] h-auto lg:h-[600px] flex items-center justify-center"
          >
            <img
              src="https://dbqa318yoj3nn.cloudfront.net/yellowstar.png"
              alt="Hexagon"
              className="absolute w-[60%] md:w-[480px] h-auto z-0"
            />
            {/* <img
              src="https://dbqa318yoj3nn.cloudfront.net/staricon.png"
              alt="Fun Learning"
              className="absolute left-0 bottom-10 w-[150px] md:w-[300px] h-auto z-20"
            /> */}
            <img
              src={hexa}
              alt="Main Image"
              className="relative w-[75%] md:w-[460px] h-auto z-10"
            />
            <img
              src={sqr}
              alt="Right Side Image"
              className="absolute right-0 top-0 w-[110px] md:w-[200px] rounded-md h-auto z-10"
            />
          </motion.div>

          <div className="w-full mx-2 lg:w-[450px] flex flex-col gap-4 mt-10 lg:mt-0">
            {[
              {
                title: "Experiential & Interactive Learning",
                text: "Activity-based sessions, roleplays, debates, simulations, real-world problem-solving.",
                bgColor: "bg-purple-200 hover:bg-purple-300",
              },
              {
                title: "Industry-Driven Curriculum",
                text: "Co-designed with recruiters, corporate leaders, and domain experts.",
                bgColor: "bg-purple-400 hover:bg-purple-500",
              },
              {
                title: "Flexible Modular Delivery",
                text: "Continuous, year-round learning through weekly/monthly modules.",
                bgColor: "bg-yellow-300 hover:bg-yellow-400",
              },
              {
                title: "Blended Learning Format",
                text: "Live expert sessions + self-paced recorded content for anytime access.",
                bgColor: "bg-blue-400 hover:bg-blue-500",
              },
              {
                title: "Personalized Mentorship & Tracking",
                text: "1:1 career mentorship, regular feedback loops, and a smart progress dashboard for students, faculty, and admin.",
                bgColor: "bg-blue-300 hover:bg-blue-400",
              },
            ].map((item, index) => (
              <div
                key={index}
                className={`flex items-center gap-4 ${item.bgColor} p-4 rounded-xl shadow-md`}
              >
                <div className=" w-6 px-2 h-6 flex items-center text-center justify-center rounded-full font-bold text-md">
                  {index + 1}.
                </div>
                <div>
                  <h3
                    className="font-bold text-lg"
                    style={{ fontFamily: "Montserrat" }}
                  >
                    {item.title}
                  </h3>
                  <p
                    className="text-sm text-gray-700"
                    style={{ fontFamily: "Poppins" }}
                  >
                    {item.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
